var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllianz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Capa_1",
    "data-name": "Capa 1",
    viewBox: "0 0 1044.3099 268.25",
    width: 1044.3099,
    height: 268.25,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs7"
  }, _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#050606;}")), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 153.64,
    y: 406.13,
    width: 1044.36,
    height: 268.25,
    id: "rect4",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_199",
    "data-name": "Grupo 199",
    transform: "translate(-153.69,-406.13)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2",
    clipPath: "url(#clip-path)",
    id: "g22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_198",
    "data-name": "Grupo 198"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_271",
    "data-name": "Trazado 271",
    className: "cls-3",
    d: "m 1064,406.15 a 134.13,134.13 0 1 0 134,134.18 v -0.23 a 130.85,130.85 0 0 0 -127.68,-134 q -3.16,-0.04 -6.32,0.05 z m 0,243.24 a 109.13,109.13 0 1 1 107.56,-110.67 c 0,0.46 0,0.92 0,1.38 A 104.87,104.87 0 0 1 1071.2,649.33 q -3.61,0.15 -7.2,0.06 z",
    style: {
      fill: "#050606"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_272",
    "data-name": "Trazado 272",
    className: "cls-3",
    d: "M 1135.23,504.59 V 610.9 h -36.55 V 489.63 h 21.59 c 10.96,0 14.96,4.22 14.96,14.96 z",
    style: {
      fill: "#050606"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_273",
    "data-name": "Trazado 273",
    className: "cls-3",
    d: "m 1082.24,470.1 v 140.8 h -36.77 v -131 a 9.83,9.83 0 0 0 -2,-7.31 5.18,5.18 0 0 0 -3.54,-1.71 l -3.54,-0.23 h -1.94 v -15.51 h 32.66 c 11.36,0 15.13,3.77 15.13,14.96 z",
    style: {
      fill: "#050606"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_274",
    "data-name": "Trazado 274",
    className: "cls-3",
    d: "M 1029.2,489.63 V 610.9 H 992.43 V 504.59 c 0,-10.74 4.23,-15 15,-15 z",
    style: {
      fill: "#050606"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_275",
    "data-name": "Trazado 275",
    className: "cls-3",
    d: "m 871.54,591.38 v 26.26 h -98.21 v -25.81 l 52.53,-73.66 h -28.09 c -6.17,0 -9.25,2.75 -9.25,8.46 v 2.28 H 774 v -22.73 a 11.81,11.81 0 0 1 13.58,-13.59 H 869 v 25.81 l -52,73 z",
    style: {
      fill: "#050606"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_276",
    "data-name": "Trazado 276",
    className: "cls-3",
    d: "m 755.86,532.68 v 85 H 716.8 v -79.29 c 0,-12.45 -1.94,-15.76 -10.16,-15.76 a 27.51,27.51 0 0 0 -21,10.5 v 84.51 H 646.57 V 516.35 c 0,-6.51 -2.74,-9.48 -9.25,-9.48 H 635 v -14.28 h 37 a 10.49,10.49 0 0 1 12,8.76 10.84,10.84 0 0 1 0,3 v 5 a 54.48,54.48 0 0 1 40.54,-18.27 30.76,30.76 0 0 1 23.52,8.79 c 6.31,6.77 7.8,13.05 7.8,32.81 z",
    style: {
      fill: "#050606"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_277",
    "data-name": "Trazado 277",
    className: "cls-3",
    d: "m 626.93,604.17 c -6.74,0 -9.25,-3.09 -9.25,-11.08 v -59.5 c 0,-31.75 -11.08,-42.71 -42.83,-42.71 a 130.6,130.6 0 0 0 -29.92,3.54 101.24,101.24 0 0 0 -26.49,9.94 l 8.68,24 a 95.51,95.51 0 0 1 38.6,-9.71 c 10.39,0 14.16,3.77 14.16,14.73 v 2.74 c -16,2.52 -21,3.54 -29.92,5.49 a 107.51,107.51 0 0 0 -14.85,4.79 36,36 0 0 0 -23.18,37.23 c 0,23.75 10.28,35.29 31.52,35.29 a 56,56 0 0 0 21,-4 74.59,74.59 0 0 0 16.67,-10.73 v 1.71 a 10.46,10.46 0 0 0 9,11.76 10,10 0 0 0 2.79,0 h 35.74 v -13.49 z m -47,-22.27 a 31.78,31.78 0 0 1 -21.24,10.73 c -7,0 -9.48,-3.54 -9.48,-12.79 0,-9.25 2.05,-13.47 9,-16.21 a 95.61,95.61 0 0 1 21.7,-5.94 z",
    style: {
      fill: "#050606"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_278",
    "data-name": "Trazado 278",
    className: "cls-3",
    d: "M 494,505.38 V 617.64 H 454.94 V 516.35 c 0,-6.51 -2.74,-9.48 -9.25,-9.48 h -2.17 v -14.28 h 37.92 a 11.71,11.71 0 0 1 12.56,10.76 11.46,11.46 0 0 1 0,2.03 z",
    style: {
      fill: "#050606"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_279",
    "data-name": "Trazado 279",
    className: "cls-3",
    d: "m 494.69,466.1 c 0,11.31 -8.23,18 -22.5,18 -13.93,0 -22.5,-6.73 -22.5,-18 0,-11.27 8.57,-17.93 22.5,-17.93 14.27,0 22.5,6.74 22.5,17.93 z",
    style: {
      fill: "#050606"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_280",
    "data-name": "Trazado 280",
    className: "cls-3",
    d: "M 426.24,463.59 V 617.64 H 387 v -143 c 0,-6.51 -2.74,-9.25 -9.25,-9.25 h -2.51 v -14.48 h 38.6 a 11.58,11.58 0 0 1 12.46,10.62 11.81,11.81 0 0 1 -0.06,2.06 z",
    style: {
      fill: "#050606"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_281",
    "data-name": "Trazado 281",
    className: "cls-3",
    d: "M 359.59,463.59 V 617.64 H 320.3 v -143 c 0,-6.51 -2.74,-9.25 -9.25,-9.25 h -2.51 v -14.48 h 38.6 a 11.53,11.53 0 0 1 12.47,10.52 12,12 0 0 1 -0.02,2.16 z",
    style: {
      fill: "#050606"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_282",
    "data-name": "Trazado 282",
    className: "cls-3",
    d: "m 265.15,464.16 a 16.2,16.2 0 0 0 -17.48,-13.25 h -62.23 v 14.51 h 5.25 c 6.51,0 9.93,2.51 9.93,7.42 a 41.62,41.62 0 0 1 -3.19,13.59 l -43.74,131.21 h 40.43 l 12,-40.2 h 47.5 l 11.31,40.2 h 44 z m -52.76,86 18.73,-61.32 16.55,61.32 z",
    style: {
      fill: "#050606"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllianz);
export default __webpack_public_path__ + "static/media/allianz.a6fa3e743c8c7ed41eea97d3a36d4986.svg";
export { ForwardRef as ReactComponent };